import { Typography } from '@mui/material';
import { useNotify } from 'react-admin';

interface CopyableIdProps {
  /** The full ID to copy */
  id: string;
  /** Number of characters to show (default: 5) */
  showChars?: number;
  /** Optional variant for Typography */
  variant?: 'body2' | 'caption';
}

/**
 * CopyableId - A clickable, truncated ID display
 *
 * Shows first N characters with "...", monospace font.
 * Click to copy full ID to clipboard with toast notification.
 */
export const CopyableId = ({
  id,
  showChars = 5,
  variant = 'body2',
}: CopyableIdProps) => {
  const notify = useNotify();

  const handleCopy = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigator.clipboard.writeText(id);
    notify('ID copied to clipboard', { type: 'info' });
  };

  return (
    <Typography
      variant={variant}
      sx={{
        color: 'text.secondary',
        fontFamily: 'monospace',
        cursor: 'pointer',
        '&:hover': { color: 'primary.main' },
      }}
      title="Click to copy full ID"
      onClick={handleCopy}
    >
      {id.substring(0, showChars)}...
    </Typography>
  );
};
